import isNumber from "lodash/isNumber";
import isNil from "lodash/isNil";
import { DateTime } from "luxon";
export const formats = [
    "yyyy-MM-dd",
    "dd.MM.yyyy, hh:mm",
    "dd.MM.yyyy",
    "yyyy",
    "d MMMM",
    "MMMM",
    "d MMMM yyyy",
    "hh:mm"
];
export const toDateTime = (value, options = {}) => {
    if (DateTime.isDateTime(value))
        return value;
    const { fromFormat } = options;
    if (isNil(value)) {
        return DateTime.invalid("Значение не передано");
    }
    if (isNumber(value)) {
        const data = new Date(value);
        return DateTime.fromISO(data.toISOString());
    }
    if (fromFormat) {
        const result = DateTime.fromFormat(value, fromFormat);
        if (result.isValid)
            return result;
    }
    const isoDate = DateTime.fromISO(value);
    if (isoDate.isValid)
        return isoDate;
    const sqlDate = DateTime.fromSQL(value);
    if (sqlDate.isValid)
        return sqlDate;
    for (const format of formats) {
        const result = DateTime.fromFormat(value, format);
        if (result.isValid)
            return result;
    }
    return DateTime.invalid("Не удалось преобразовать в DateTime");
};
